import moment from 'moment-timezone';
import config from '../../config';
import { fetchM } from './fetchM';
import { handleError } from './error';
import {
  BANKS_REQUEST,
  BANKS_SUCCESS,
  BANKS_FAILURE,
} from '../constants/actions';

function banksRequest() {
  return {
    type: BANKS_REQUEST,
  };
}

function banksSuccess(data, token = null) {
  return {
    type: BANKS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function banksError(message) {
  return {
    type: BANKS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchBanks(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(banksRequest());
    if (!fresh) {
      let banksData = {};
      try {
        banksData = JSON.parse(localStorage.getItem(`${config.get('appName')}.banks`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !banksData.data ||
        config.get('version') !== banksData.version ||
        moment().isAfter(moment(banksData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(banksSuccess(banksData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM(`${config.get('apiURL')}/banks/`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          localStorage.setItem(`${config.get('appName')}.banks`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(banksSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, banksError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/banks.js